<template>
  <div class="fill-height">
    <dialogos-app :dialogos="dialogos" :personaje="false" @update:currentText="showButtons = true, $refs.audioPlayer.playAudio($event)"></dialogos-app>
    <v-layout class="wrap-md-and-down" align-center="">
      <v-flex class="flex-img">
        <img class="instructor" src="../../assets/presentacion/diapositiva-2.png" alt="instructor">
      </v-flex>
      <v-flex xs12 pl-4>
        <v-layout align-center>
          <svg-button v-if="showButtons" @click.native="$set(vistos,0,true)" class="flex-button-img animated zoomIn"></svg-button>
          <p v-if="vistos[0]" class="animated fadeIn green-border flex xs12 mb-0">Describir los aspectos generales de las reservas y los recursos de hidrocarburos, su clasificación, métodos de estimación y normatividad correspondientes.</p>
        </v-layout>
        <v-layout align-center mt-3>
          <svg-button v-if="showButtons" @click.native="$set(vistos,1,true)" class="flex-button-img animated zoomIn dura-1"></svg-button>
          <p v-if="vistos[1]" class="animated fadeIn green-border flex xs12 mb-0">Identificar los principales métodos de estimación de cantidades recuperables de recursos y reservas de hidrocarburos.</p>
        </v-layout>
      </v-flex>
    </v-layout>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Presentacion/AUDIO 03',
    'Presentacion/AUDIO 04',
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButton from '../../assets/presentacion/diapositiva 2_2';
export default {
  components: {SvgButton},
  data() {
    return {
      vistos: Array(2).fill(false),
      showButtons: false,
      dialogos: [
        "Bienvenido al curso El ABC de las Reservas y los Recursos de Hidrocarburos. Yo seré el tutor que te acompañará en el desarrollo del curso. ¡Comencemos!",
        "Al finalizar el módulo estarás en capacidad de identificar la importancia que tienen las reservas y los recursos de hidrocarburos, sus definiciones e impacto. Adicionalmente, aprenderás a: <span class='instruccion'>haz clic en los iconos.</span>" 
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(value) {
      var todosVistos = value.every(el => {return el})
      if (todosVistos) {
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.flex-img {
  flex-basis: 512px;
  @media (max-width: 960px){
    flex-basis: 312px;
  }
}

.flex-button-img {
  flex-basis: 80px;
  z-index: 2;
  >* {
    width: 80px;
  }
}

.green-border {
  border: 1px solid #CEF48C;
  padding: 15px;
  padding-left: 40px;
  position: relative;
  left: -30px;
}

.instructor{}
</style>
